/**
 * @deprecated: Use ProductPricingType instead
 **/
export enum BillingModel {
  Standard = 'Standard',
  Stairstep = 'Stairstep',
  Tiered = 'Tiered',
}
